import { queryOptions, useQuery } from '@tanstack/react-query';
import { apiClient } from '../../lib/util';

export function useRetrievePersonioCompensationTypes(companyId: string, options = {}) {
  return useQuery({
    queryKey: ['company', companyId, 'settings', 'payroll', 'compensationTypes'],
    queryFn: () =>
      apiClient.integrations.companiesPersonioListCompensationTypesRetrieve({
        parentCompany: companyId
      }),
    ...options
  });
}

export function getPersonioCheckQueryOptions(
  companyId: string,
  onSuccess?: (data?: unknown) => void,
  onError?: (error: unknown) => void
) {
  return queryOptions({
    queryKey: ['company', companyId, 'personio', 'check'],
    queryFn: async () => {
      try {
        const res = await apiClient.integrations.companiesPersonioCheckRetrieve({
          parentCompany: companyId
        });

        if (onSuccess) {
          onSuccess(res);
        }

        return res;
      } catch (error) {
        if (onError) {
          onError(error);
        }
        console.error(error);
        throw error;
      }
    }
  });
}
